module.exports = __webpack_public_path__ + "static/media/login_bg_3_1920x1080.ea4283d9.jpg";